define.alias("ember-drag-sort/components/drag-sort-item", "settings/components/drag-sort-item");